export function hasDraggableData(entry) {
  if (!entry) return false
  const data = entry.data.current
  return data?.type === 'Column' || data?.type === 'Task'
}
